import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const Menu = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  width: 35px;
`;

const Item = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  line-height: 1.33;
  margin-bottom: 5px;
  padding: 5px 0 5px 5px;
  text-align: center;
  user-select: none;
  transition: var(--ph-background-transition);
  background-color: var(--white);
  border-radius: 50%;
  width: 30px;
  height: 30px;

  &:hover {
    outline: 3px solid var(--white);
  }
`;

const Icon = styled(Svg)`
  height: 15px;
  width: 15px;
  fill: #999;
  stroke-width: 2px;
  top: 50%;
  transform: translateY(-50%);
`;

const Label = styled('div')`
  display: none;
  margin-left: 10px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-100);
`;

const PopupWrapper = styled('div')`
  position: absolute;
  right: calc(100% - 18rem);
  top: 4rem;
  z-index: 9999;
  overflow: hidden;
  border-radius: var(--ph-border-radius-sm);
  box-shadow: var(--ph-box-shadow-sm);
  background-color: var(--white);
  padding: 25px;
  width: 500px;
  max-height: 450px;
  overflow-y: auto;

  &.sideBarCollapsed {
    right: calc(100% - 17.5rem);
  }
`;

const Badge = styled('div')`
  background-color: var(--dark-notification-red);
  border-radius: 50%;
  position: absolute;
  top: 7px;
  left: 28px;
  padding: 2px 4px;
  font-size: 10px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
`;

const PopupTitle = styled('div')`
  font-size: var(--ph-heading-three);
  font-weight: 400;
  color: var(--black);
  margin: 0;
  padding: 0;
  margin-bottom: 20px;
`;

const Notification = styled('div')`
  position: relative;

  & + & {
    margin-top: 25px;
  }
`;

const NotificationMark = styled(Svg)`
  width: 18px;
  position: absolute;
  left: 0;
  top: 0;
`;

const NotificationText = styled('div')`
  margin-left: 25px;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: var(--black);
  margin-bottom: 10px;

  &.active {
    font-weight: 600;
  }
`;

const NotificationPublishDate = styled('div')`
  margin-left: 25px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  display: inline-block;
`;

const NotificationReadBtn = styled('div')`
  user-select: none;
  cursor: pointer;
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--ph-orange-500);
  padding: 4px 10px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
  display: inline-block;
  margin-left: 25px;
`;

export default {
  Menu,
  Item,
  Icon,
  Label,
  PopupWrapper,
  Badge,
  PopupTitle,
  Notification,
  NotificationMark,
  NotificationText,
  NotificationPublishDate,
  NotificationReadBtn,
};
